import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, type Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import type {
  DocumentEndpointListData,
  DocumentEndpointListEnvelope,
} from '../models/document-endpoint.model';

export interface DocumentEndpointListParams {
  category?: string;
  search?: string;
}

@Injectable({ providedIn: 'root' })
export class DocumentEndpointService {
  private readonly http = inject(HttpClient);
  private readonly base = `${environment.apiBaseUrl}/v1/document-endpoints`;

  list(params?: DocumentEndpointListParams): Observable<DocumentEndpointListData> {
    let httpParams = new HttpParams();
    if (params?.category) {
      httpParams = httpParams.set('category', params.category);
    }
    if (params?.search) {
      httpParams = httpParams.set('search', params.search);
    }

    return this.http
      .get<DocumentEndpointListEnvelope>(this.base, { params: httpParams })
      .pipe(map(res => res.data));
  }
}
